import { render, staticRenderFns } from "./NewsSupplier.vue?vue&type=template&id=e242fa00&"
import script from "./NewsSupplier.vue?vue&type=script&lang=js&"
export * from "./NewsSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports